"use client";

import { Shield, CircleDot, Armchair, ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Services() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const services = [{
    number: "01",
    title: "OTA Management",
    description: "Optimize your presence on booking platforms to increase visibility and drive direct revenue growth.",
    Icon: CircleDot
  }, {
    number: "02",
    title: "Tech Integration",
    description: "Expert guidance on selecting and implementing the right hospitality tech stack for your property.",
    Icon: Shield
  }, {
    number: "03",
    title: "Revenue Audits",
    description: "Comprehensive analysis of your current performance to identify untapped revenue opportunities.",
    Icon: Armchair
  }];
  return <section data-section-id="2675" id="marketingservicesoverview" className="relative bg-background text-foreground overflow-hidden py-32 md:py-40 px-6 md:px-10">
      {}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[600px] opacity-60" style={{
      background: "radial-gradient(ellipse 80% 60% at 50% 0%, hsl(43 72% 52% / 0.08), transparent 70%)"
    }} aria-hidden="true" />

      {}
      <div className="absolute top-0 left-0 right-0 h-px bg-border" aria-hidden="true" />

      <div className="relative mx-auto max-w-7xl">
        {}
        <div ref={headerRef} className={`flex flex-col items-center text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground mb-8">
            Our Core Services
          </span>

          {}
          <h2 className="font-serif font-default text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight max-w-4xl">
            Revenue growth.{" "}
            <span className="italic font-light bg-gradient-to-b from-foreground to-muted-foreground bg-clip-text text-transparent">
              Data-driven.
            </span>
          </h2>

          <p className="mt-8 max-w-xl text-base md:text-lg text-muted-foreground font-default">
            We provide actionable strategies to help hotel owners maximize profitability and efficiency.
          </p>
        </div>

        {}
        <div ref={gridRef} className={`mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {services.map((service, i) => {
          const Icon = service.Icon;
          return <div key={service.number} data-index={i} className="group relative overflow-hidden rounded-lg border border-border bg-card p-8 md:p-10 transition-all duration-[400ms] ease-[cubic-bezier(0.22,1,0.36,1)] hover:-translate-y-1.5 hover:border-primary/50" style={{
            transitionDelay: `${i * 80}ms`
          }}>
                {}
                <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-[400ms] group-hover:opacity-100" style={{
              background: "linear-gradient(180deg, hsl(222 47% 11%) 0%, hsl(222 47% 15%) 100%)"
            }} aria-hidden="true" />

                {}
                <div className="pointer-events-none absolute left-0 top-0 w-px h-0 transition-all duration-[600ms] ease-out group-hover:h-full" style={{
              background: "linear-gradient(180deg, transparent 0%, hsl(43 72% 52%) 50%, transparent 100%)"
            }} aria-hidden="true" />

                <div className="relative flex flex-col h-full">
                  {}
                  <div className="relative mb-10">
                    <div className="absolute inset-0 opacity-0 blur-2xl transition-opacity duration-[400ms] group-hover:opacity-60" style={{
                  background: "radial-gradient(circle, hsl(43 72% 52% / 0.4) 0%, transparent 60%)"
                }} aria-hidden="true" />
                    <Icon className="relative h-12 w-12 stroke-[1] text-primary transition-all duration-[400ms] group-hover:text-primary" strokeWidth={1} />
                  </div>

                  {}
                  <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground/70 mb-4">
                    {service.number} / 03
                  </span>

                  {}
                  <h3 className="font-default text-2xl md:text-[28px] font-medium leading-tight mb-4 text-foreground">
                    {service.title}
                  </h3>

                  {}
                  <p className="text-base text-muted-foreground leading-relaxed mb-10 font-default">
                    {service.description}
                  </p>

                  {}
                  <div className="flex-grow" />

                  {}
                  <Link to="/ServicesPage" className="group/link inline-flex items-center gap-2 text-sm font-medium text-primary self-start">
                    <span className="relative">
                      View Details
                      <span className="absolute left-0 -bottom-0.5 h-px w-0 transition-all duration-500 ease-out group-hover/link:w-full" style={{
                    background: "linear-gradient(90deg, hsl(43 72% 52%) 0%, hsl(43 72% 52% / 0.4) 100%)"
                  }} aria-hidden="true" />
                    </span>
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" />
                  </Link>
                </div>
              </div>;
        })}
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-border" aria-hidden="true" />
    </section>;
}